import type { OrderImageItem } from '@/api/orders/types'

export const ORDER_FEED_LIMIT = 50

function compareOrderItems(left: OrderImageItem, right: OrderImageItem): number {
  const timeDifference = Date.parse(right.orderedAt) - Date.parse(left.orderedAt)
  if (Number.isFinite(timeDifference) && timeDifference !== 0) return timeDifference
  return right.orderItemId - left.orderItemId
}

/** Hält die sichtbaren Karten nach inkrementellen Feed-Antworten aktuell. */
export function mergeOrderItems(
  current: readonly OrderImageItem[],
  incoming: readonly OrderImageItem[],
): readonly OrderImageItem[] {
  const byOrderItemId = new Map<number, OrderImageItem>()
  for (const item of current) byOrderItemId.set(item.orderItemId, item)
  for (const item of incoming) byOrderItemId.set(item.orderItemId, item)

  return [...byOrderItemId.values()].sort(compareOrderItems).slice(0, ORDER_FEED_LIMIT)
}
